import React, { FC } from 'react'
import { MODAL_CANCEL_FAILED_TITLE, MODAL_CANCEL_FAILED_CONTENT, MODAL_NOTI_AGREE_BTN } from '../../../../constants/richmenu'
import { PrimaryConfirmModal } from '../../../molecules/ModalContainer/PrimaryDialogTemplate/PrimaryConfirmDialog'

interface ErrorCancelModalProps {
  onSubmit: any
}

export const ErrorCancelModal: React.FC<ErrorCancelModalProps> = props => {
  return (
    <PrimaryConfirmModal
      header={MODAL_CANCEL_FAILED_TITLE}
      content={MODAL_CANCEL_FAILED_CONTENT}
      onSubmit={props.onSubmit}
      label={MODAL_NOTI_AGREE_BTN}
      skipButton={false}
    />
  )
}
